import Loading from "./loading";
import Loadable from "react-loadable";
import Error404 from "../pages/404";
// 0.3s延迟，避免加载组件时的闪烁。有时组件加载非常快，小于 200ms，提示加载的组件会在界面上一闪而过。
const delay = 300;
// 15s为加载为超时
const timeout = 15000;
const Routers = [
  {
    path: "/collection/404",
    strict: true,
    exact: true,
    component: Error404,
  },
  {
    path: "/collection/:id",
    strict: true,
    exact: true,
    component: Loadable({
      loader: () => import("../pages/home"),
      loading: Loading,
      delay: delay,
      timeout: timeout,
    }),
  },
  {
    path: "/*",
    strict: true,
    exact: true,
    component: Error404,
    // https://m-test.thepaper.cn/wap/resource/htmlstatic/errPage.html?code=404
  },
];

export default Routers;
